export enum KeyCode {
  Enter = 13,
  Esc = 27,
  ArrowUp = 38,
  ArrowDown = 40,
}
